const rankings = [
  {
    rank: 1,
    title: '流浪地球2',
    category: '科幻 / 冒险',
    heat: '9.6',
    desc: '太阳危机之下，人类团结一致开启流浪之旅，视效震撼',
  },
  {
    rank: 2,
    title: '周处除三害',
    category: '动作 / 犯罪',
    heat: '9.4',
    desc: '通缉犯决心除掉排名前二的恶人，以暴制暴的黑暗传奇',
  },
  {
    rank: 3,
    title: '热辣滚烫',
    category: '剧情 / 喜剧',
    heat: '9.2',
    desc: '宅女通过拳击找到自我，燃爆人生的逆袭之路',
  },
  {
    rank: 4,
    title: '第二十条',
    category: '剧情 / 法律',
    heat: '9.1',
    desc: '法条背后的人情冷暖，现实题材引发全民讨论',
  },
  {
    rank: 5,
    title: '飞驰人生2',
    category: '喜剧 / 运动',
    heat: '8.9',
    desc: '昔日车神重返赛场，笑中带泪的赛车热血之旅',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-3">
            热播榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            本周最受观众喜爱的高清影视TOP5
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {rankings.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer group"
            >
              <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center font-heading text-lg md:text-xl font-bold ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-400 text-background-50'
                  : item.rank === 3
                  ? 'bg-primary-300 text-background-50'
                  : 'bg-secondary-300 text-foreground-100'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-100 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="flex-shrink-0 text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded">
                    {item.category}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 truncate">
                  {item.desc}
                </p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1 text-accent-500">
                <i className="ri-star-fill text-sm"></i>
                <span className="text-sm font-bold">{item.heat}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}